import { render, staticRenderFns } from "./MultipaneResizer.vue?vue&type=template&id=aad15cd2&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MultipaneResizer.vue"
export default component.exports